import { createSlice } from '@reduxjs/toolkit'
import { fetchUsers } from '@services/UserService'
import { fetchVenues } from '@services/VenueService'
import { TableParams } from '@supplement-bacon/sb-table-filters'

import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { userSchema, venueSchema } from '../models/schema'

type SearchItem = {
  ids: number[]
  isLoading: boolean
}

type State = {
  query: TableParams
  users: SearchItem
  venues: SearchItem
}

const initialSearch = {
  pagination: {
    current: 1,
    pageSize: 10,
  },
}

const initialSearchItem: SearchItem = {
  ids: [],
  isLoading: false,
}

const initialState: State = {
  query: initialSearch,
  users: initialSearchItem,
  venues: initialSearchItem,
}

const slice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setVenuesLoading(state, action) {
      state.venues.isLoading = true
    },
    setUsersLoading(state, action) {
      state.users.isLoading = true
    },

    setUserIds(state, action) {
      state.users.isLoading = false
      state.users.ids = action.payload
    },

    setVenueIds(state, action) {
      state.venues.isLoading = false
      state.venues.ids = action.payload
    },

    reset(state) {
      state.query = initialSearch
      state.users = initialSearchItem
      state.venues = initialSearchItem
    },
  },
})

// Reducer
export default slice.reducer

export const { setVenueIds, reset: resetSearch } = slice.actions

/**
 * Actions
 */

export const getSearchVenues = (params: TableParams) =>
  SBAPI.FetchPaginatedDispatched(
    fetchVenues(params),
    [venueSchema],
    slice.actions,
    slice.actions.setVenuesLoading,
    slice.actions.setVenueIds,
    false
  )

export const getSearchUsers = (params: TableParams) =>
  SBAPI.FetchPaginatedDispatched(
    fetchUsers(params),
    [userSchema],
    slice.actions,
    slice.actions.setUsersLoading,
    slice.actions.setUserIds,
    false
  )
